import { useProjectsStore } from '@modules/projects/stores/projects.store'
import { useWorkspacesStore } from '@modules/workspaces/stores/workspaces.store'

import { WORKSPACE_NOTIFICATION_CHANNEL } from '../../settings.const'
import type {
  WorkspaceNotificationChannel,
  WorkspaceNotificationGroup,
  WorkspaceNotificationGroupId,
  WorkspaceNotificationId,
  WorkspaceSettings,
} from '../../settings.interface'
import { workspaceToSettings } from '../objects'

/** Builds settings for the current workspace from the workspaces and projects stores. */
export function resolveWorkspaceSettings(): WorkspaceSettings | null {
  const { currentWorkspace } = useWorkspacesStore.getState()
  if (!currentWorkspace) return null

  return {
    ...workspaceToSettings(currentWorkspace),
    projectCount: useProjectsStore.getState().projects.length,
  }
}

export function getNextWorkspaceIndex(currentIndex: number, remainingCount: number): number {
  if (remainingCount === 0) return -1
  if (currentIndex < 0) return 0

  return Math.min(currentIndex, remainingCount - 1)
}

export function updateNotificationChannel(
  notifications: WorkspaceNotificationGroup[],
  notificationId: WorkspaceNotificationId,
  channel: WorkspaceNotificationChannel,
  enabled: boolean
): void {
  for (const group of notifications) {
    const item = group.items.find((notification) => notification.id === notificationId)
    if (item) {
      item.channels[channel] = enabled
      return
    }
  }
}

export function updateGroupChannels(
  notifications: WorkspaceNotificationGroup[],
  groupId: WorkspaceNotificationGroupId,
  enabled: boolean,
  channel?: WorkspaceNotificationChannel
): void {
  const group = notifications.find((item) => item.id === groupId)
  if (!group) return

  for (const notification of group.items) {
    if (channel) {
      notification.channels[channel] = enabled
    } else {
      notification.channels[WORKSPACE_NOTIFICATION_CHANNEL.EMAIL] = enabled
      notification.channels[WORKSPACE_NOTIFICATION_CHANNEL.IN_APP] = enabled
    }
  }
}
